var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true)?_c('div',{staticClass:"message-container"},_vm._l((_vm.getAllMessages),function(message){return _c('div',{staticClass:"alert",class:_vm.getMessageClass(message.type)},[_c('span',[_vm._v("\n      "+_vm._s(message.message)+"\n    ")])])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ce4a352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Messages.vue
// module id = 8mYD
// module chunks = 9